import { PublishedWithChanges } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { API_PATH, handleApiResponse } from "../Internal/api.js";
import { Button, Tooltip } from "@mui/joy";


export default function CheckSetup(props) {

    const intermediateState = useSelector(state => state.intermediateState);
    const decay = useSelector(state => state.decay);
    const finalStateData = useSelector(state => state.finalState);
    const currentBackend = useSelector(state => state.backend.currentBackend);
    const totalData = useSelector(state => state);
    const dispatch = useDispatch();

    const getCheckResponse = () => {
        console.log(JSON.stringify({
            intermediateState: intermediateState,
            decay: decay,
            finalState: finalStateData,
            backend: currentBackend
        }));
        const code = API_PATH + "check";
        fetch(code, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                intermediateState: intermediateState,
                decay: decay,
                finalState: finalStateData,
                backend: currentBackend
            })
        })
        .then(response => handleApiResponse(response, dispatch))
        .then(data => {
            console.log(data);
            dispatch({"type": "SET_GRAPH_CHECK", "payload": data});
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    return (
        <Tooltip title="Check current setup for fesability" placement="top">
            <Button onClick={getCheckResponse} >
                <PublishedWithChanges/>
            </Button>
        </Tooltip>
    )
};
